import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hand20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.25 1.25C6.86929 1.25 5.75 2.36929 5.75 3.75V11.25H5C3.48122 11.25 2.25 12.4812 2.25 14V18H3.75V14C3.75 13.3096 4.30964 12.75 5 12.75H5.75V15.8519H7.25V3.75C7.25 3.19772 7.69771 2.75 8.25 2.75C8.80228 2.75 9.25 3.19772 9.25 3.75V14H10.75V10.3056H12.75V14H14.25V10.3056H15C15.6904 10.3056 16.25 10.8652 16.25 11.5556V18H17.75V11.5556C17.75 10.0368 16.5188 8.80556 15 8.80556H10.75V3.75C10.75 2.36929 9.63071 1.25 8.25 1.25Z'
      fill='currentColor'
    />
  </Svg>
);

Hand20.displayName = 'Hand20';
export default Hand20;
